module.exports = __webpack_public_path__ + "static/SELANG-5280967917807bbda57df791c73ae26a.png";